// src/services/api.js
import axios from 'axios';

const API_URL = '/api';

// Helper function to get auth header
const getAuthHeader = () => {
    const token = sessionStorage.getItem('authToken');
    return token ? { Authorization: token } : {};
};

const api = {
    getPosts: async () => {
        try {
            console.log('Fetching posts from:', `${API_URL}/posts`);
            const response = await axios.get(`${API_URL}/posts`);
            console.log('Posts response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    getPost: async (slug) => {
        try {
            console.log('Fetching post:', slug);
            const response = await axios.get(`${API_URL}/posts/${slug}`);
            console.log('Post response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    createPost: async (postData) => {
        try {
            const response = await axios.post(`${API_URL}/posts`, postData, {
                headers: getAuthHeader()
            });
            console.log('Create post response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    updatePost: async (slug, postData) => {
        try {
            const response = await axios.put(`${API_URL}/posts/${slug}`, postData, {
                headers: getAuthHeader()
            });
            console.log('Update post response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    deletePost: async (slug) => {
        try {
            const response = await axios.delete(`${API_URL}/posts/${slug}`, {
                headers: getAuthHeader()
            });
            console.log('Delete post response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    getCategories: async () => {
        try {
            const response = await axios.get(`${API_URL}/categories`);
            console.log('Categories response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    searchPosts: async (query) => {
        try {
            const response = await axios.get(`${API_URL}/posts/search?q=${query}`);
            console.log('Search response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    },

    login: async (username, password) => {
        try {
            const response = await axios.post(`${API_URL}/auth/login`, {
                username,
                password
            });
            console.log('Login response:', response);
            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }
};

export default api;